<template>
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <vuexy-logo />
      <h2 class="brand-text text-primary ml-1">
        Breeze
      </h2>
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          {{ content.title }}
        </h2>
        <p class="mb-2">
          {{ content.message }}
        </p>

        <p
          v-if="hydrationError && reason === 'hydration'"
          class="text-muted small mb-2"
        >
          {{ hydrationError }}
        </p>

        <div class="d-flex justify-content-center">
          <b-button
            v-if="reason === 'expired'"
            variant="primary"
            class="mb-2 btn-sm-block"
            @click="logout"
          >
            Log in again
          </b-button>
          <template v-else>
            <b-button
              variant="primary"
              class="mb-2 btn-sm-block mr-1"
              :disabled="retrying"
              @click="retry"
            >
              {{ retrying ? 'Retrying…' : 'Try again' }}
            </b-button>
            <b-button
              variant="outline-secondary"
              class="mb-2 btn-sm-block"
              @click="logout"
            >
              Log out
            </b-button>
          </template>
        </div>

        <b-img
          fluid
          :src="imgUrl"
          alt="Something went wrong"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { mapGetters } from 'vuex'
import {
  BLink, BButton, BImg,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'

const MESSAGES = {
  expired: {
    title: 'Your session has expired ⏰',
    message: 'Your session has expired, please log in again.',
  },
  hydration: {
    title: 'We can’t load your account 😟',
    message: 'Something went wrong while loading your account. Please try again in a moment.',
  },
  partner: {
    title: 'Account not found 🔍',
    message: 'We couldn’t find a partner account for your login. Please contact support if this keeps happening.',
  },
  organization: {
    title: 'No organization linked 🏢',
    message: 'Your account isn’t linked to an organization yet, so the portal can’t be used. Please contact support.',
  },
  location: {
    title: 'No location available 📍',
    message: 'There’s no location set up for your account. Please contact support to configure it correctly.',
  },
}

export default {
  name: 'SessionUnavailable',
  components: {
    VuexyLogo,
    BLink,
    BButton,
    BImg,
  },
  data() {
    return {
      retrying: false,
      downImg: require('@/assets/images/pages/error.svg'),
    }
  },
  computed: {
    ...mapGetters({
      hydrationError: 'authentication/hydrationError',
    }),
    reason() {
      return this.$route.query.reason || 'hydration'
    },
    content() {
      return MESSAGES[this.reason] || MESSAGES.hydration
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/error-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
  methods: {
    retry() {
      this.retrying = true
      // Force a fresh hydration, then return home (the guard re-checks entities).
      this.$store.dispatch('authentication/ensureHydrated', true)
        .then(status => {
          if (status === 'ready') {
            this.$router.push('/')
          }
        })
        .finally(() => {
          this.retrying = false
        })
    },
    logout() {
      this.$store.dispatch('authentication/logout')
      this.$router.push({ name: 'login' })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
